import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const DeleteItemModel = ({
  deleteItem,
  setDeleteItem,

  refetch,
}) => {
  const navigate = useNavigate();
  const { _id, itemName } = deleteItem;

  const handleDelete = (id) => {
    const url = `${process.env.REACT_APP_ENDPOINT}/item/${id}`;
    const config = {
      headers: {
        authorization: `${localStorage.getItem("token")}`,
      },
    };

    axios.delete(url, config).then((data) => {
      if (data.status === 200) {
        toast.success(`${itemName} is Deleted Successfully`, {
          theme: "colored",
        });
        refetch();
        setDeleteItem(null);
        navigate(-1);
      } else {
        toast.error(`Can't Delete ${itemName}`, { theme: "colored" });
      }
    });
  };
  return (
    <div>
      <input type="checkbox" id="delete-item-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box dark:bg-secondary">
          <h3 className="font-bold text-lg text-black dark:text-white">{`Are you sure You Want to Delete ${itemName}?`}</h3>
          <div className="modal-action">
            <button
              onClick={() => handleDelete(_id)}
              className="btn btn-sm btn-outline btn-error"
            >
              Confirm
            </button>
            <label
              onClick={() => setDeleteItem(null)}
              htmlFor="delete-item-modal"
              className="btn btn-sm"
            >
              Cancel
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteItemModel;
